angular.module('zc.zenclerkS')
  .component('zcsCampaignsListItem', {
    require: ['?campaign', '?filters'],
    bindings: {
      project: '<',
      campaign: '<',
      filters: '<',
      onUpdate: '&'
    },
    templateUrl: '/templates/zenclerk_s/sites/campaigns/list/item.html',
    controller: zcsCampaignCardController
  });


zcsCampaignCardController.$inject = [
  '$filter',
  '$q',
  '$state',
  '$translate',
  'Devise',
  'Campaign',
  'CampaignStatsV2',
  'ReportCampaignStats',
  'Project',
  'campaignStatuses',
  'currencies',
  'ZcsCampaignStats',
  'ZcsEstimator'
];
function zcsCampaignCardController(
  $filter,
  $q,
  $state,
  $translate,
  Devise,
  Campaign,
  CampaignStatsV2,
  ReportCampaignStats,
  Project,
  campaignStatuses,
  currencies,
  ZcsCampaignStats,
  ZcsEstimator
) {

  const vm = this;
  let state;

  vm.$onInit = () => {
    vm.state = {}; // Keep tracking of the states of elements
    vm.Project = Project;
    vm.Devise = Devise;
    vm.currency = currencies[vm.project.currency];
    vm.state = {}; // Keep tracking of the states of elements

    vm.startAt = moment(vm.campaign.start_at).startOf('day');
    vm.chartStartAt = moment(vm.campaign.start_at).startOf('day');

    if(moment(vm.campaign.end_at).isBefore(moment())) {
      if(moment(vm.campaign.end_at).subtract(1, 'month').startOf('day').isBefore(moment(vm.campaign.start_at))) {
        vm.chartStartAt = moment(vm.campaign.start_at);
      } else {
        vm.chartStartAt = moment(vm.campaign.end_at).subtract(1, 'month');
      }
    } else if(moment().subtract(1, 'month').startOf('day').isAfter(vm.startAt)) {
      // Show last month by default
      vm.chartStartAt = moment().subtract(1, 'month').startOf('day');
    }

    vm.startAt = vm.startAt.toDate();
    vm.canShow = !['incomplete', 'preview', 'pending'].includes(vm.campaign.current_status);
    vm.canEdit = ['incomplete', 'preview', 'pending'].includes(vm.campaign.current_status);
    vm.canDestroy = ['incomplete', 'preview'].includes(vm.campaign.status);
    vm.currentStatusText = campaignStatuses[vm.campaign.current_status].text;
    vm.isStarted = vm.campaign.start_at_obj.date >= Date.now();
    vm.isPastCampaign = vm.campaign.end_at && moment(vm.campaign.end_at).isBefore();
    vm.showStats = !['incomplete', 'preview', 'pending'].includes(vm.campaign.current_status);
    vm.totalDeliveryCount = 0;
    vm.totalConversionCount = 0;
    vm.goToSummary = goToSummary;
    vm.chartData = {};
    vm.goToEdit = goToEdit;
    vm.goToConfirm = goToConfirm;
    vm.removeCampaign = removeCampaign;

    // set the current end date (in timestamp) if the campaign is not finish yet
    vm.chartEndAt = vm.campaign.end_at_obj.date > Date.now() ? Date.now() : vm.campaign.end_at_obj.date;
    vm.currentEnd = moment(vm.campaign.end_at_obj.date).startOf('day').toDate();

    prepareChartData();
  };

  function prepareChartData() {
    // For anything before 2016-12-01, we need to use CampaignStatsV2 (from zenclerk).
    // After 2016-12-01 we will use the new zcs shuukei
    const campaignStatsStart = moment(vm.startAt).isBefore(moment('2016-12-01'))
      ? moment(vm.startAt).toDate()
      : false;
    const campaignStatsEnd = moment(vm.campaign.end_at).isAfter(moment('2016-12-01'))
      ? moment('2016-12-01').toDate()
      : moment(vm.campaign.end_at).toDate();

    const zcsCampaignStatsStart = moment(vm.startAt).isBefore(moment('2016-12-01'))
      ? moment('2016-12-01').toDate()
      : moment(vm.startAt).toDate();
    const zcsCampaignStatsEnd = moment(vm.campaign.end_at).isBefore(moment('2016-12-01'))
      ? false
      : moment(vm.campaign.end_at).toDate();

    const campaignStatsV2Promise = campaignStatsStart
      ? CampaignStatsV2.find({
        dimension: 'daily',
        apikey: vm.project.apikey,
      }, {
        campaign_id: vm.campaign.id,
        is_control: false,
        start_at: {
          $gte: campaignStatsStart,
          $lt: campaignStatsEnd
        }
      })
      : $q.resolve([]);

    const zcsCampaignStatsPromise = zcsCampaignStatsEnd
      ? ZcsCampaignStats.find({
        dimension: 'daily',
        apikey: vm.project.apikey,
      }, {
        campaign_id: vm.campaign.id,
        start_at: {
          $gte: zcsCampaignStatsStart,
          $lt: zcsCampaignStatsEnd
        }
      })
      : $q.resolve([]);

    $q.all([
      campaignStatsV2Promise,
      zcsCampaignStatsPromise
    ]).then(([campaignStats, zcsCampaignStats]) => {

      vm.totalDeliveryCount =
        _.sumBy(campaignStats, d => d.delivery_count) +
        _.sumBy(zcsCampaignStats, d => d.delivery_count);
      vm.totalConversionCount =
        _.sumBy(campaignStats, d => d.conversion_count) +
        _.sumBy(zcsCampaignStats, d => d.effective_conversion_count);
      vm.totalConversionPrice =
        _.sumBy(campaignStats, d => d.conversion_price) +
        _.sumBy(zcsCampaignStats, d => d.effective_conversion_price);
      vm.totalConversionPercentage = (vm.totalConversionCount / vm.totalDeliveryCount) * 100;
      vm.averageConversionPrice = vm.totalConversionPrice / vm.totalConversionCount;

      let deliveriesByDate = _.groupBy(campaignStats, d => moment(d.start_at).format('YYYY-MM-DD'));
      deliveriesByDate = populateMissingDate(deliveriesByDate, 'delivery_count', vm.chartStartAt, vm.chartEndAt);

      let zcsDeliveriesByDate = _.groupBy(zcsCampaignStats, d => moment(d.start_at).format('YYYY-MM-DD'));
      zcsDeliveriesByDate = populateMissingDate(zcsDeliveriesByDate, 'delivery_count', vm.chartStartAt, vm.chartEndAt);

      deliveriesByDate = deliveriesByDate.concat(zcsDeliveriesByDate);
      // chart data array
      vm.chartData.delivery = [{
        values: deliveriesByDate,
        label: $translate.instant('sites.campaigns.list.itemDirective.deliveryCount')
      }];

      //# Conversion
      let conversionByDate = _.groupBy(campaignStats, d => moment(d.start_at).format('YYYY-MM-DD'));
      conversionByDate = populateMissingDate(conversionByDate, 'conversion_count', vm.chartStartAt, vm.chartEndAt);

      let zcsConversionByDate = _.groupBy(zcsCampaignStats, d => moment(d.start_at).format('YYYY-MM-DD'));
      zcsConversionByDate = populateMissingDate(zcsConversionByDate, 'effective_conversion_count', vm.chartStartAt, vm.chartEndAt);

      conversionByDate = conversionByDate.concat(zcsConversionByDate);

      // chart data array
      vm.chartData.conversion = [{
        values: conversionByDate,
        label: vm.project.invoice_calculation_type === 'normal'
          ? $translate.instant('sites.campaigns.list.itemDirective.couponUsedCount')
          : $translate.instant('sites.campaigns.list.itemDirective.convertedUser')
      }];
    });
  }

  function goToSummary() {
    if(!vm.canShow) {
      return false;
    }
    $state.go('zenclerkS.project.campaign.summary', {apikey: vm.project.apikey, campaignId: vm.campaign.id});
  }

  function goToEdit(step) {
    state = 'admin.projects.campaigns.edit';
    if(step) { state += `.${step}` }
    return $state.go(state, {campaignId: vm.campaign.id});
  }

  function goToConfirm() {
    $state.go('admin.projects.campaigns.confirm', {campaignId: vm.campaign.id});
  }

  // function to populate empty value
  function populateMissingDate(data, dataKey, startAt, endAt) {
    let dateKeys = [];
    let date;
    if(moment(startAt).isBefore(endAt)) {
      date = moment(startAt).valueOf();
    } else {
      date = moment(endAt).valueOf();
    }
    let lastDate = moment(endAt).add(1, 'days').valueOf();
    while(date <= lastDate) {
      dateKeys.push(moment(date).format('YYYY-MM-DD'));
      date = moment(date).add(1, 'days').valueOf();
    }

    data = _.map(dateKeys, function(dateKey) {
      if(data[dateKey]) {
        return { x: dateKey, y: _.sumBy(data[dateKey], d => d[dataKey]) };
      }
      return { x: dateKey, y: 0 };
    });
    return data;
  }

  // FIXME: copypaste from campaign_action_menu
  function removeCampaign(campaign) {
    const campaignObject = _.merge({}, campaign);
    if(campaignObject.status === 'incomplete') {
      // If it has not ran yet, destroy (note that we also exclude preview because
      // it has been in publish.js and there can be data with that campaign id)
      return Campaign.destroy({projectId: vm.project.id, campaignId: campaignObject.id})
        .then(res => $state.go('zenclerkS.project.campaigns.draft', {apikey: vm.project.apikey}, { reload: true }));
    }

    // Otherwise, make it terminated
    // Note, we need to use "terminate" because just updating status
    // would not set end_at to the moment it was terminated!
    return Campaign.terminate({projectId: vm.project.id, campaignId: campaignObject.id}, campaignObject)
      .then(res => {
        campaign.status = 'terminated';
        $state.go('zenclerkS.project.campaigns.active', {apikey: vm.project.apikey}, { reload: true });
      });
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/list/item.directive.js